<template>
    <div class="goods_index">
        <div class="shop_top"><shop-top @search_goods="to_search" :subnav_show="false" :cart_change="cart_change" :change_color="true"></shop-top></div>
        <div class="mbx width_center_1200">
            <el-breadcrumb separator="/" v-if="classification">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item  v-for="item in classnameCut(classification)" :key="item"><a :href="'/goods/params/?keyword=' + item">{{item}}</a></el-breadcrumb-item>
                <el-breadcrumb-item><a>产品列表</a></el-breadcrumb-item>
            </el-breadcrumb>
            <el-breadcrumb separator="/" v-else>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a>产品列表</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="goods_where width_center_1200">

            <div class="goods_cat_list" v-if="crowd">
                <div class="goods_cat_title">适用人群：</div>
                <ul >
                    <li :class="info.crowd==null?'font_color':''" @click="ProductCrowd_change(null)">全部</li>
                    <li v-for="(v,k) in crowd" :key="k" @click="ProductCrowd_change(v.crowd)" :class="info.crowd==v.crowd?'font_color':''">{{v.crowd}}</li>
                </ul>
            </div>



            <div class="goods_cat_list">
                <div class="goods_cat_title">剂型：</div>
                <ul>
                    <li :class="info.form==null?'font_color':''" @click="ProductForm_change(null)">全部</li>
                    <li v-for="(v,k) in form_list" v-if="k <= 10" :key="k" @click="ProductForm_change(v.formName)" :class="info.form==v.formName?'font_color':''">{{v.formName}}</li>
                    <li @click="zform()" v-show="info.length > 10" style="float:right; cursor: pointer; line-height: 30px; margin:10px; text-align: center;">{{sform?"收起":"展开"}}</li>
                    <li v-show="sform" v-for="(v,k) in form_list" v-if="k > 10" :key="k" @click="ProductForm_change(v.formName)" :class="info.form==v.formName?'font_color':''">{{v.formName}}</li>
                </ul>
                
            </div>


            <div class="goods_cat_list" v-if="spec">
                <div class="goods_cat_title">规格：</div>
                <ul>
                    <li :class="info.spec==null?'font_color':''" @click="ProductSpec_change(null)">全部</li>
                    <li v-for="(v,k) in spec" v-if="k <= 10" :key="k" @click="ProductSpec_change(v.specName)" :class="info.spec==v.specName?'font_color':''">{{v.specName}}</li>
                    <li @click="zspec()" v-show="spec.length > 10"  style="float:right; cursor: pointer; line-height: 30px; margin:10px; text-align: center;">{{sspec?"收起":"展开"}}</li>
                    <li v-show="sspec" v-for="(v,k) in spec" v-if="k > 10 && k<40" :key="'item'+k" @click="ProductSpec_change(v.specName)" :class="info.spec==v.specName?'font_color':''">{{v.specName}}</li>
                </ul>
                
            </div>



            <div class="goods_cat_list"  v-if="unit">
                <div class="goods_cat_title">单位：</div>
                <ul>
                    <li :class="info.unit==null?'font_color':''" @click="ProductUnit_change(null)">全部</li>
                    <li v-for="(v,k) in unit" :key="k" @click="ProductUnit_change(v.unitName)" :class="info.unit==v.unitName?'font_color':''">{{v.unitName}}</li>
                    <li @click="zunit()" v-show="unit.length > 10" style="float:right; cursor: pointer; line-height: 30px; margin:10px; text-align: center;">{{sunit?"收起":"展开"}}</li>
                    <li v-show="sunit" v-for="(v,k) in unit"  v-if="k > 10" :key="k" @click="ProductUnit_change(v.unitName)" :class="info.unit==v.unitName?'font_color':''">{{v.unitName}}</li>
                </ul>
                 <!-- <div @click="zunit()" v-show="unit.length > 10" style="float:right; cursor: pointer; line-height: 50px; width: 50px; text-align: center;">{{sunit?"收起":"展开"}}</div> -->
            </div>

            

            <div class="goods_cat_list"  v-if="mfrs">
                <div class="goods_cat_title">厂家：</div>
                <ul>
                    <li :class="info.mfrsId==null?'font_color':''" @click="ProductMfrs_change(null)">全部</li>
                    <li v-for="(v,k) in mfrs" v-if="k <= 5" :key="k" @click="ProductMfrs_change(v.id)" :class="info.mfrsId==v.id?'font_color':''">{{v.name}}</li>
                    <li @click="zmfrs()" v-show="mfrs.length > 5" style="float:right; cursor: pointer; line-height: 30px; margin:10px; text-align: center;">{{smfrs?"收起":"展开"}}</li>
                    <li v-show="smfrs" v-for="(v,k) in mfrs"  v-if="k > 5 && k < 20" :key="'item'+k" @click="ProductMfrs_change(v.id)" :class="info.mfrsId==v.id?'font_color':''">{{v.name}}</li>
                </ul>
            </div>


            
                        <!-- <div class="goods_cat_list">
                <div class="goods_cat_title">品牌筛选：</div>
                <ul>
                    <li :class="info.goods_brand==0?'font_color':''" @click="brand_change(0)">全部</li>
                    <li v-for="(v,k) in brand_list" :key="k" @click="brand_change(v.id)" :class="info.goods_brand==v.id?'font_color':''">{{v.name}}</li>
                </ul>
            </div> -->
            <div class="goods_cat_list"  v-if="list.length > 0">
                <div class="goods_cat_title">筛选排序：</div>
                <ul class="goods_sort_ul">



    <li @click="goods_sort_click(1)" :class="info.sort==1?'font_color':''">新品
        <!-- <span class="goods_sort_top"><i :style="(info.sort==0)?'color:#F56C6C':''" class="icon iconfont">&#xe7fe;</i></span>
        <span class="goods_sort_bottom"><i :style="(info.sort==1)?'color:#F56C6C':''" class="icon iconfont">&#xe7ff;</i></span> -->
        </li>
    <li @click="goods_sort_click(2)" :class="info.sort==2?'font_color':''">销量
        <!-- <span class="goods_sort_top"><i :style="(info.sort==2)?'color:#F56C6C':''" class="icon iconfont">&#xe7fe;</i></span>
        <span class="goods_sort_bottom"><i :style="(info.sort==2)?'color:#F56C6C':''" class="icon iconfont">&#xe7ff;</i></span>-->
        </li> 
    <li @click="goods_sort_click(3)" :class="info.sort==3?'font_color':''">价格从低到高
        <!-- <span class="goods_sort_top"><i :style="(info.sort==3)?'color:#F56C6C':''" class="icon iconfont">&#xe7fe;</i></span>
        <span class="goods_sort_bottom"><i :style="(info.sort==4)?'color:#F56C6C':''" class="icon iconfont">&#xe7ff;</i></span> -->
        </li>
    <li @click="goods_sort_click(4)" :class="info.sort==4?'font_color':''">价格从高到低
        <!-- <span class="goods_sort_top"><i :style="(info.sort==3)?'color:#F56C6C':''" class="icon iconfont">&#xe7fe;</i></span>
        <span class="goods_sort_bottom"><i :style="(info.sort==4)?'color:#F56C6C':''" class="icon iconfont">&#xe7ff;</i></span> -->
        </li>



                </ul>
            </div>
        </div>

        <div class="goods_list width_center_1200" v-if="list.length > 0">

           
            <div class="goods_list_item" v-for="(v,k) in list" :key="k">
                
                <dl>
                <!-- <div v-if="v.selltype == 3" class="sold_out"></div> -->
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <img v-if="v.groupsName != '' && v.groupsName != null && v.groupsName[0].groupsImg  && v.groupsName[0].groupsImg !=null" :src="filePath + v.groupsName[0].groupsImg" class="tag" />
                <dt v-if="v.imgFront != null">
                    <img v-if="v.selltype == 2 && v.is_ControlSales == false" src="/pc/noproduct.png" :alt="v.name" :title="v.name">
                    <img v-else-if="v.selltype == 3" src="/pc/noproduct.png" :alt="v.name" :title="v.name">
                    <img v-else :src="filePath + v.imgFront" :alt="v.name" :title="v.name">
                </dt>
                <dt v-else-if="v.imgFront == null && v.imgSide != null"><img :src="filePath + v.imgSide" :alt="v.name" :title="v.name"></dt>
                <dt v-else-if="v.imgFront == null && v.imgSide == null && v.imgBack != null"><img :src="filePath + v.imgBack" :alt="v.name" :title="v.name"></dt>
                <dt v-else><img src="/pc/nopic.png" :alt="v.name" :title="v.name"></dt>

                <dd class="p-icons">
                    <i  v-for="(vo,key) in v.groupsName" :key="key" :class="'goods-icons'+ vo.id +' goods-icons J-picon-tips J-picon-fix'">{{vo.name}}</i>
                </dd>

                <!-- 新增是否追溯码显示 -->
                <dd class="p-icons" v-if="v.yjm">
                    <el-tag type="danger" style="color: #f56c6c;" >追溯码</el-tag>
                </dd>

                <dd class="title" :title="v.name">{{v.name}}</dd>

                <dd class="ftitle" :title="v.mfrs" v-if="v.selltype == 2 && v.is_ControlSales == false">厂家:</dd>
                <dd class="ftitle" :title="v.mfrs" v-else-if="v.selltype == 3">厂家:</dd>
                <dd class="ftitle" :title="v.mfrs" v-else>{{v.mfrs}}</dd>

                <dd class="parameter">规格:{{v.spec}}</dd>

                <dd class="parameter" v-if="v.exp == '9999-12-30T16:00:00.000+00:00'">效期:-</dd>
                <dd class="parameter" v-else>效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.selltype == 2 && v.is_ControlSales == false">库存:0</dd>
                <dd class="parameter" v-else-if="v.stock >= 200">库存:充足</dd>
                <dd class="parameter" v-else-if="v.stock < 200">库存:{{v.stock}}</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                <!-- <dd class="price" v-if="isLogin == false" :title="会员可见">会员可见</dd>
                <dd class="price" v-else-if="isLogin == true && v.is_ControlSales == false">授权查看</dd>
                <dd class="price" v-else-if="isLogin == true && v.nowprice == null ">￥{{v.price}}</dd>
                <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd> -->
                    <dd class="price" v-if="v.is_ControlSales == false">授权查看</dd>
                    <dd class="price" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</dd>
                    <dd class="price" v-else-if="v.nowprice == null && v.price != null">￥{{v.price}}</dd>
                    <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd>
                </router-link>

                    <dd  class="item-operate">
                    <div class="num-operate" v-if="v.price == null && v.nowprice == null">
                        <span class="num-subtract">-</span>
                        <input v-model="v.max" v-enter-number type="text" @on-change="changenum(v)" class="j_num" @change="changenum(v)" disabled>
                        <span class="num-add">+</span>
                    </div>
                    <div class="num-operate" v-else>
                        <span class="num-subtract" @click="change_buy_num(v,false)">-</span>
                        <input v-model="v.max" v-enter-number type="text" @on-change="changenum(v)" class="j_num" @change="changenum(v)">
                        <span class="num-add" @click="change_buy_num(v,true)">+</span>
                    </div>
                    <div @click="loginUser(v)" v-if="v.price == null && v.nowprice == null" class="j_addCart addcart">请登录</div>
                    <div @click="add_cart(v)" v-else class="j_addCart addcart">加入购物车</div>
                    </dd>
                </dl>
               
            </div>
            
        </div>
        

        
        

        <div class="home_empty_list" style="margin: 50px 0;" v-else>
            <i class="font iconfont">&#xe600;</i>暂无获取到相对应数据！
        </div>

        <div class="home_fy_block  width_center_1200" v-if="list.length > 0">


            <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total" :page-size="pageSize" :current-page="pageNum"></el-pagination>
        </div>

        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <ShopMbar></ShopMbar>
        
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
import {formatDate} from '@/utils/date';
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
    },
    props: {},
    data() {
      return {
          class_list:[],
          brand_list:[],
          goods_list:[],
          list:[],
          props:{
              value:'id',
              label:'name',
              checkStrictly:true,
          },
          goods_type:0,
          info:{
              keyword:null,
              pageNum:1,
              pageSize:10,
              getProductAttribute:null,
              goods_brand:null,
              form:null,
              crowd:null,
              spec:null,
              unit:null,
              mfrs:{
                mfrsId:null,
                name:null,
              },
              mfrsId:null,
              sort:0,
          },
          filePath:null,
          spec:{},
          pageNum:1,
          pageSize:10,
          scrowd:false,
          sform:false,
          sspec:false,
          sunit:false,
          smfrs:false,
          form_list:[],
          crowd:null,
          unit:null,
          mfrs:{
                mfrsId:null,
                name:null,
          },
          mfrsId:null,
          isLogin:false,
          groupsImg:null,
          headers: { "Content-Type": "application/x-www-form-urlencoded"},
          classification:{},

      };
    },
    watch: {
        info:{
            handler(){
                this.search_goods();
                this.$forceUpdate();
            },
            deep:true,
        }
    },
    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    computed: {},
    methods: {
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },


      classnameCut(name){
            if(typeof name !== 'string'){
            name = name.toString();
            }
            let classname = name.split(",")
            return classname
      },
        // 购买数量修改
        change_buy_num:function(e,type){
            if(type){
                if(e.max +1 > e.stock){
                    return this.$message.error('库存不足');
                }
                e.max += e.mini_qty;
            }else{
                if(e.max <= e.mini_qty){
                    return this.$message.error('最低购买数量为 '+ e.mini_qty);
                }
                e.max -= e.mini_qty;
            }
        },

         changenum:function(e){
            if(e.max <= e.mini_qty){
                e.max = e.mini_qty
            }else{
                if(e.max < e.stock){
                    if(Math.round(e.max / e.stock) <= 1){
                        e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty
                    }else{
                        e.max = (Math.ceil(e.stock / e.mini_qty)-1) * e.mini_qty
                    }
                }else if(e.max > e.stock){
                        if(Math.round(e.max / e.stock) < 1){
                            e.max = Math.ceil(e.stock / e.mini_qty) * e.mini_qty + e.mini_qty
                        }else if(Math.round(e.max / e.stock) == 1){
                            e.max = Math.ceil(e.stock / e.mini_qty) * e.mini_qty
                        }else{
                            e.max = (Math.ceil(e.stock / e.mini_qty)-1) * e.mini_qty
                        }
                }else{
                        if(Math.ceil(e.max / e.mini_qty) * e.mini_qty > e.stock){

                            e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty - e.mini_qty
                        }else if(Math.ceil(e.max / e.mini_qty) * e.mini_qty == e.stock){
                            e.max = e.stock
                        }else{
                            e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty
                        }
                }
            }
        },


         //获取用户登录信息
        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res.code==200){
                    this.isLogin = true;
                    this.user_info = res.data;
                }else if(res.code == 401){
                    this.isLogin = false;
                }else{
                    this.isLogin = false;
                }

            });
        },


        zcrowd:function () {
                this.scrowd = !this.scrowd;
            },
        zform:function () {
                this.sform = !this.sform;
            },
        zspec:function () {
                this.sspec = !this.sspec;
            },
        zunit:function () {
                this.sunit = !this.sunit;
            }, 
        zmfrs:function () {
                this.smfrs = !this.smfrs;
            }, 

        // 获取属性信息
        get_getProductAttribute_list:function(){
            if(this.$route.query.keyword != undefined){
                this.$get(this.$api.getProductAttribute + '?keyword=' + this.$route.query.keyword+'&platId=' + this.$platId).then(res=>{
                    if(res.code == 200){
                    this.crowd = res.data.crowd;
                    this.form_list = res.data.form;
                    this.spec = res.data.spec;
                    this.unit = res.data.unit;
                    this.mfrs = res.data.mfrs;
                    this.platId = this.$platId;
                        for (let i = 0; i < this.mfrs.length; i++) {
                            this.mfrs[i].name = res.date.mfrs[i].name;
                            this.mfrs[i].mfrsId = res.date.mfrs[i].id;
                        }
                    }else{
                    this.crowd = null;
                    this.form_list = null;
                    this.spec = null;
                    this.unit = null; 
                    this.mfrs = null;
                    this.platId = this.$platId;
                    }

                });
            }else if(this.$route.query.productCategoryName != undefined){
                this.$get(this.$api.getProductAttribute + '?keyword=' + this.info.keyword+'&platId=' + this.$platId).then(res=>{
                    if(res.code == 200){
                    this.crowd = res.data.crowd;
                    this.form_list = res.data.form;
                    this.spec = res.data.spec;
                    this.unit = res.data.unit;
                    this.mfrs = res.data.mfrs;
                    this.platId = this.$platId;
                        for (let i = 0; i < this.mfrs.length; i++) {
                            this.mfrs[i].name = res.date.mfrs[i].name;
                            this.mfrs[i].mfrsId = res.date.mfrs[i].id;
                        }
                    }else{
                    this.crowd = null;
                    this.form_list = null;
                    this.spec = null;
                    this.unit = null; 
                    this.mfrs = null;
                    this.platId = this.$platId;
                    }

                });
            }

        },



        // 商品列表
        // getList:function(){ 
        //     this.$get(this.$api.queryGoodsAll,{pageSize:this.pageSize,pageNum:this.pageNum}).then(res=>{
        //         // this.list = res.data.list;
        //         // this.total = res.data.total;
        //         // this.pageNum = res.data.pageNum;
        //         // this.pageSize = res.data.pageSize;
        //         // this.totalPage = res.data.totalPage;

        //     });
        // },

        // 分页改变
        current_change:function(e){
             this.pageNum = e;
             this.search_goods();
             this.$scrollTo();
        },


        // 搜索指定产品
        search_goods:function(){
            this.info.pageNum = this.pageNum;
            this.info.platId = this.$platId;
            this.$get(this.$api.homeSearchGoods,this.info).then(res=>{
                this.list = res.data.list;
                for (var i = 0; i < this.list.length; i++) {
                    // if(this.list[i].max == null){
                       this.list[i].max = res.data.list[i].mini_qty;
                    // }
                }
                // if(res.data.list[0].groupsName){
                //         this.groupsImg = res.data.list[0].groupsName[0].groupsImg
                //     }
                this.pageSize = res.data.pageSize;
                this.pageNum = res.data.pageNum + 1;
                this.total = res.data.total;
            });
        },
        //  获取商品分类列表 选择商品
        // get_goods_class_list:function(){
        //     this.$get(this.$api.goodsCategory).then(res=>{
        //         this.goods_class = res.data;
        //     });
        // },
        // 选择分类的选择框改变
        // classChange:function(){
        //     this.$forceUpdate();
        //     this.search_goods();
        // },
        // 获取品牌信息
        // get_brand_list:function(){
        //     this.$get(this.$api.getProductAttribute+'?'+this.$route.query.keyword).then(res=>{
        //         this.brand_list = res.data.form;
        //     });
        // },
        // brand_change:function(e){
        //     this.info.goods_brand = e;
        // },


        ProductCrowd_change:function(e){
            this.info.crowd = e;
            this.scrowd = false;
            this.pageNum = 1;
        },
        ProductForm_change:function(e){
            this.info.form = e;
            this.sform = false;
            this.pageNum = 1;
        },
        ProductSpec_change:function(e){
            this.info.spec = e;
            this.sspec = false;
            this.pageNum = 1;
        },
        ProductUnit_change:function(e){
            this.info.unit= e;
            this.sunit = false;
            this.pageNum = 1;
        },
        ProductMfrs_change:function(e){
            this.info.mfrsId= e;
            this.smfrs = false;
            this.pageNum = 1;

        },
        goods_sort_click:function(e){
           this.info.sort = e;
        },

        // 子组件执行搜索
        to_search:function(e){
            this.info.keyword = e.keyword;
            this.search_goods();
            //this.$forceUpdate();
        },


        get_search_where:function(){
            //alert(this.$route.query.keyword);
            // console.log(this.$route.query.keyword);
            // console.log(this.info.keyword);
            if(this.$route.query.keyword != undefined){
                let params = 'keyword=' + this.$route.query.keyword;
                let paramsArr = params.split('|');
                    paramsArr.forEach(res=>{
                        let paramsInfo = [];
                        paramsInfo = res.split('=');
                        if(paramsInfo[0] == 'keyword'){  // 搜索关键词
                            if(paramsInfo.length==2){
                                this.info.keyword = paramsInfo[1];
                            }else{
                                this.info.keyword = '';
                            }
                            this.search_goods();
                        }
                        if(paramsInfo[0] == 'brand_id'){//品牌
                            if(paramsInfo.length==2){
                                this.info.goods_brand = paramsInfo[1];
                            }else{
                                this.info.goods_brand_id = 0;
                            }
                        }
                        if(paramsInfo[null] == 'crowd'){//适用人群
                            if(paramsInfo.length==2){
                                this.info.crowd = paramsInfo[1];
                            }else{
                                this.info.crowd = null;
                            }
                        }
                        if(paramsInfo[null] == 'spec'){//规格
                            if(paramsInfo.length==2){
                                this.info.spec = paramsInfo[1];
                            }else{
                                this.info.spec = null;
                            }
                        }
                        if(paramsInfo[null] == 'form'){//剂型
                            if(paramsInfo.length==2){
                                this.info.form = paramsInfo[1];
                            }else{
                                this.info.form = null;
                            }
                        }
                        if(paramsInfo[null] == 'unit'){//单位
                            if(paramsInfo.length==2){
                                this.info.unit = paramsInfo[1];
                            }else{
                                this.info.unit = null;
                            }
                        }
                        if(paramsInfo[null] == 'unit'){//厂家
                            if(paramsInfo.length==2){
                                this.info.mfrsId = paramsInfo[1];
                            }else{
                                this.info.mfrsId = null;
                            }
                        }
                        if(paramsInfo[0] == 'sort'){//排序
                            if(paramsInfo.length==2){
                                this.info.sort = paramsInfo[1];
                            }else{
                                this.info.sort = 0;
                            }
                        }
                    });
                    this.search_goods();
            }else if(this.$route.query.productCategoryName != undefined){
                let params = '?keyword=' + this.info.keyword;
                let paramsArr = params.split('|');
                    paramsArr.forEach(res=>{
                        let paramsInfo = [];
                        paramsInfo = res.split('=');
                        if(paramsInfo[0] == 'keyword'){  // 搜索关键词
                            if(paramsInfo.length==2){
                                this.info.keyword = paramsInfo[1];
                            }else{
                                this.info.keyword = '';
                            }
                            this.search_goods();
                        }
                        if(paramsInfo[0] == 'brand_id'){//品牌
                            if(paramsInfo.length==2){
                                this.info.goods_brand = paramsInfo[1];
                            }else{
                                this.info.goods_brand_id = 0;
                            }
                        }
                        if(paramsInfo[null] == 'crowd'){//适用人群
                            if(paramsInfo.length==2){
                                this.info.crowd = paramsInfo[1];
                            }else{
                                this.info.crowd = null;
                            }
                        }
                        if(paramsInfo[null] == 'spec'){//规格
                            if(paramsInfo.length==2){
                                this.info.spec = paramsInfo[1];
                            }else{
                                this.info.spec = null;
                            }
                        }
                        if(paramsInfo[null] == 'form'){//剂型
                            if(paramsInfo.length==2){
                                this.info.form = paramsInfo[1];
                            }else{
                                this.info.form = null;
                            }
                        }
                        if(paramsInfo[null] == 'unit'){//单位
                            if(paramsInfo.length==2){
                                this.info.unit = paramsInfo[1];
                            }else{
                                this.info.unit = null;
                            }
                        }
                        if(paramsInfo[null] == 'unit'){//厂家
                            if(paramsInfo.length==2){
                                this.info.mfrsId = paramsInfo[1];
                            }else{
                                this.info.mfrsId = null;
                            }
                        }
                        if(paramsInfo[0] == 'sort'){//排序
                            if(paramsInfo.length==2){
                                this.info.sort = paramsInfo[1];
                            }else{
                                this.info.sort = 0;
                            }
                        }
                    });
                    this.search_goods();
            }
            

           // this.$forceUpdate();
        },

        loginUser:function(){
           this.$router.push('/user/login');
        },

        // 加入购物车
        add_cart:function(e){
            let date1 = Math.floor(new Date().getTime() / 1000);
            let date2 = Math.floor(new Date(e.exp).getTime() / 1000);
            //let date3 = new Date(new Date(new Date(e.exp).toLocaleDateString()).getTime());
            // let expTime = date3.getFullYear() + "-" + ((date3.getMonth() + 1) < 10 ? "0" + (date3.getMonth() + 1):(date3.getMonth() + 1))+ "-" + (date3.getDate() < 10 ? "0" + date3.getDate():date3.getDate()) + " " + (date3.getHours()<10?"0"+date3.getHours():date3.getHours()) + ":" + (date3.getMinutes()<10?"0"+date3.getMinutes():date3.getMinutes()) + ":" + (date3.getSeconds()<10?"0"+date3.getSeconds():date3.getSeconds());
            // let date1 = new Date(new Date(new Date(this.exp).toLocaleDateString()).getTime());
            // if(data1 + 31104000 >= date2){
            //         alert('商品效期为' + date2);
            // }
            // if(e.exp != null){
            //     if(date2-date1 <= '31104000'){
            //         //alert('该商品为近效期商品');
            //         this.$message.error('该商品为近效期商品');
            //     }
            // }

            if(date2-date1 <= '31104000' && e.exp != null ){
                this.$confirm("该商品为近效期商品, 是否继续?", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                        if(e.max == null){
                            return this.$message.error('购买数量不正确');
                        }else if(e.max <= e.stock ){
                        this.$post(this.$api.homeAddCart,{"rows":[{goodsId:e.id,curPrice:e.curPrice,qty:e.max,platId:this.$platId,companyId:e.companyId,operId:null,promoId:null,promoPrice:e.promoPrice}],platId:this.$platId}).then(res=>{
                            if(res.code == 200){
                                if(res.data=='加入购物车成功'){
                                    this.search_goods();
                                    this.get_cart_count();
                                    this.cart_change += 1; // 修改购物车数据
                                    return this.$message.success('加入购物车成功');
                                }
                                else{
                                    return this.$message.error(res.data);
                                }
                            }else if(res.code == 500){
                                if(res.message=='请登录'){
                                    this.$message.error('请先登录！');
                                    return this.$router.push('/user/login');
                                }else{
                                    return this.$message.error('加入购物车失败'); 
                                }
                            }else{
                                return this.$message.error(res.message);
                            }
                        });  
                        }else{
                            return this.$message.error('库存不足');
                            //this.diasabledInput = true
                        }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                    });
            }else{
                        if(e.max == null){
                            return this.$message.error('购买数量不正确');
                        }else if(e.max <= e.stock ){
                        this.$post(this.$api.homeAddCart,{"rows":[{goodsId:e.id,curPrice:e.curPrice,qty:e.max,platId:this.$platId,companyId:e.companyId,operId:null,promoId:null,promoPrice:e.promoPrice}],platId:this.$platId}).then(res=>{
                            if(res.code == 200){
                                if(res.data=='加入购物车成功'){
                                    this.search_goods();
                                    this.get_cart_count();
                                    this.cart_change += 1; // 修改购物车数据
                                    return this.$message.success('加入购物车成功');
                                }
                                else{
                                    return this.$message.error(res.data);
                                }
                            }else if(res.code == 500){
                                if(res.message=='请登录'){
                                    this.$message.error('请先登录！');
                                    return this.$router.push('/user/login');
                                }else{
                                    return this.$message.error('加入购物车失败'); 
                                }
                            }else{
                                return this.$message.error(res.message);
                            }
                        });  
                        }else{
                            return this.$message.error('库存不足');
                            //this.diasabledInput = true
                        }
            }


            // setTimeout(()=>{
            //     this.diasabledInput=false 
            // },2000);

        },

        get_cart_count:function(){
            this.$get(this.$api.homeGetCartCount,{platId:this.$platId}).then(res=>{
                this.cart_change = res.data
            });
        },


    },
    created() {
        if(this.$route.query.keyword != ''){
         this.classification = this.$route.query.keyword;
         this.info.keyword = this.$route.query.keyword;
        }else{
         this.classification = null
        }
        if(this.$route.query.productCategoryName){
            this.classification = this.$route.query.productCategoryName;
            this.info.keyword = this.$route.query.productCategoryName;
        }else{
          this.classification = null
        }
        this.filepath();
        this.get_user_info();
        this.get_search_where();
        this.get_getProductAttribute_list();

    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.goods_index{
    background: #fff;
}
.goods_sort_top{
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.goods_sort_bottom{
    position: relative;
    color:#666;
    cursor: pointer;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.mbx{
    margin:20px auto;
}
.goods_where{
    border:1px solid #efefef;
    background: #fff;
    line-height: 50px;
    font-size: 14px;
    .goods_cat_list,.home_goods_cat_list{
        border-bottom: 1px solid #efefef;
        // padding-left:20px; 
        // height: 50px;
        line-height: 50px;
        .goods_cat_title{
            width: 80px;
            float: left;
            text-align: center;
            height: 50px;
            line-height: 50px;
        }
        ul{
            // float: left;
        }
        ul.goods_sort_ul{
            li{
                margin-right: 30px;
            }
        }
        ul li{
            float: left;
            color:#666;
            line-height: 30px;
            margin: 10px;
            cursor: pointer;
            a{
                color:#666;
            }
            a:hover{
                color:#409EFF;
            }
        }
        li:hover{
            color:#409EFF;
        }
        ul li.font_color{
            color:#409EFF;
        }
        
    }
    .goods_cat_list:after{
        content:'';
        clear:both;
        display: block;
    }
    .goods_cat_list:last-child{
        border-bottom: none;
    }
}
.goods_list{
    margin:40px auto;
    .goods_list_item{
        float: left;
        width: 224px;
        height: 445px;
        box-sizing: border-box;
        margin: 0 20px 20px 0;
        background: #fff;
        dl{
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: 224px;
            height: 445px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:25px auto 20px auto;
                display: block;
            }
        }
        dl dt img{
            width: 180px;
            height: 180px;
            margin:20px auto 20px auto;
            display: block;
        }
        dl dd{
            font-size: 14px;
            padding: 0 15px;
            width: 194px;
        }
        dl .parameter{
            font-size: 14px;
            color:#666666;
            line-height: 22px;
            height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        dl dd.title{
            color: #000;
            height: 30px;
            line-height: 30px;
            // text-align: center;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 40px;
            text-align: left;
            font-size: 16px;
            overflow: hidden;
            font-weight: bold;
        }
        dl dd.price span{
            font-size: 14px;
            color: #b0b0b0;
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: normal;
            line-height: 40px;
            // float:right;
        }
        dl dd span:last-child{
            text-align: right;
        }
        // dl dd span:first-child:hover{
        //     color:#fff;
        //     background: #F56C6C;
        // }
        // dl dd span{
        //     width: 50%;
        //     display: block;
        //     float: left;
        //     line-height: 20px;
        //     text-align: left;
        // }
    }
    .goods_list_item:nth-child(5n){
        margin-right: 0;
    }
    // .goods_list_item:hover{
    //     // border:1px solid #F56C6C;
    // }
    .goods_list_item:hover dl{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
.goods_list_item a:hover .title{
	color:#409EFF;
}
}
.sold_out{
    position: absolute;
    width: 224px;
    height: 445px;
    background: url("/public/pc/sold_out.png");
    z-index: 665;
}
.tag{
    position: absolute;
    text-align: right;
    float: right;
    width: 223px;
    height: 223px;
    z-index: 9;
}
</style>